import { FC } from 'react';
import { Tag } from 'antd';
import { SyncOutlined } from '@ant-design/icons';

export const LoadingTag: FC = () => {
	return <Tag icon={<SyncOutlined spin />}>--</Tag>;
};
